import { AfterViewInit, Component, OnInit, QueryList, ViewChildren, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';

import { MessagesService, NotifyService } from '@fry/lib/utils';
import { BookingItem, BookingItemsStore } from '@fry/booking/lib/booking-items';
import { catchError, map, switchMap } from 'rxjs/operators';
import { EasFormGroup } from '@fry/components/common/easform';
import { BookingOptionParts } from '@fry/booking/lib/booking-items/booking-items.constants';
import { Booking } from '@fry/booking/lib/bookings';
import { BuilderStateService } from '@fry/components/common/form-builder/builder.state.service';
import { EasBuilderTransition } from '@fry/components/common/form-builder/builder.interfaces';
import { Profile } from '@fry/lib/profile';
import { BookingItemIntegrationOptionComponent } from './booking-item-integration-option.component';

@Component({
    selector: 'eas-booking-item-integration',
    templateUrl: './booking-item-integration.component.html',
    providers: [
        MessagesService,
        BuilderStateService,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BookingItemIntegrationComponent implements OnInit, AfterViewInit {
  @ViewChildren(BookingItemIntegrationOptionComponent) optionComponents: QueryList<BookingItemIntegrationOptionComponent>;

  public bookingItem$: Observable<BookingItem>;
  public easFormGroup$: Observable<EasFormGroup>;
  public workflow: any = {};
  public bookableOptions$: Observable<any[]>;
  public availableParts = BookingOptionParts;
  bookingItem: BookingItem;
  error: string;

  constructor(
    private route: ActivatedRoute,
    private notify: NotifyService,
    private bookingItems: BookingItemsStore

  ) { }

  user: Profile;
  public selectedBookings: {booking: Booking, transitions: EasBuilderTransition[]}[] = [];
  private _transitions$ = new BehaviorSubject<EasBuilderTransition[]>([]);

  transitions$ = this._transitions$.asObservable();

  ngAfterViewInit() {
    // Start init on the option components
    this.optionComponents.changes.subscribe((val: QueryList<BookingItemIntegrationOptionComponent>) => {
      val.reduce((obs: Observable<boolean>, itm) => {
        return obs.pipe(switchMap(() => itm.init()));
      }, of(true)).subscribe();
    });
  }

  ngOnInit() {
    this.bookingItem$ = this.route.data.pipe(
      map(data => {
        this.bookingItem = data.bookingItem;
        this.workflow = data.bookingItem.workflow;
        this.bookableOptions$ = this.bookingItems.getBookableOptions(data.bookingItem.doc._id);
        return data.bookingItem;
      }),
      catchError(error => {
        this.error = error;
        this.notify.error(error);
        return throwError(error);
      }),
    );
  }
}
